export var EHRErrorCode;
(function (EHRErrorCode) {
    EHRErrorCode["mfaDisabled"] = "MFA_DISABLED";
    EHRErrorCode["invalidFileType"] = "INVALID_FILE_TYPE";
})(EHRErrorCode || (EHRErrorCode = {}));
